(function () {
  'use strict';

  angular.module('app').component('tourPickupPriceDetail', tourPickupPriceDetail());

  function tourPickupPriceDetail() {
    return {
      bindings: {
        tourPickupPrices: '=',
        tour: '=',
        paxRanges: '=',
        seasonSelected: '=',
        priceListSelected: '=',
        zones: '=',
        onTourPickupPricesSaved: '&',
        onTourPickupPricesCanceled: '&',
      },
      controller: TourPickupPriceDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/tour-prices/tour-pickup-price-detail/tour-pickup-price-detail.component.html',
    };
  }

  TourPickupPriceDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TourPriceService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function TourPickupPriceDetailComponent(config, UtilService, TourPriceService, paxRangeService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.saveTourPickupPrices = saveTourPickupPrices;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          //selectPaxRange(item);
          setZonesData();
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          //selectPaxRange(paxRangeToSelect);
          setZonesData();
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.tourPickupPrices.length > 0) {
        // Edit and exists prices
        setSelectedPaxRanges();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.tourPickupPrices[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_PICKUP_PRICES';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_PICKUP_PRICES';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setSelectedPaxRanges() {
      vm.paxRangesSelected = [];

      vm.tourPickupPrices.forEach(function (tourPickupPrice) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && tourPickupPrice.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Seta all prices from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.zonesData = [];

      vm.zones.forEach(function (zone) {
        zone.pax_ranges = [];

        vm.paxRanges.forEach(function (paxRange) {
          var tourPickupPriceId;
          var servicePrice = 0;

          // Exist tour pickup prices
          if (vm.tourPickupPrices.length) {
            for (var i = 0; i < vm.tourPickupPrices.length; i++) {
              var tourPickupPrice = vm.tourPickupPrices[i];

              if (
                tourPickupPrice.zone_id === zone.id &&
                tourPickupPrice.pax_range_id === paxRange.id
              ) {
                tourPickupPriceId = tourPickupPrice.id;

                servicePrice = tourPickupPrice.service_price;
                break;
              }
            }
          }

          var visible = false;
          for (var j = 0; j < vm.paxRangesSelected.length; j++) {
            var paxRangeSelected = vm.paxRangesSelected[j];
            if (paxRange.id === paxRangeSelected.id) {
              visible = true;
              break;
            }
          }

          var zonePaxRange = {
            id: paxRange.id,
            service_price: servicePrice,
            pax_from: paxRange.pax_from,
            visible: visible,
            tourPickupPriceId: null,
          };

          if (tourPickupPriceId) {
            zonePaxRange.tourPickupPriceId = tourPickupPriceId;
          }

          zone.pax_ranges.push(zonePaxRange);
        });

        vm.zonesData.push(zone);
      });
    }

    // Show/hide zone pax ranges, based on the paxRangesSelected
    function setZonesData() {
      vm.zonesData.forEach(function (zone) {
        zone.pax_ranges.forEach(function (pax_range) {
          var visible = false;
          for (var j = 0; j < vm.paxRangesSelected.length; j++) {
            var paxRangeSelected = vm.paxRangesSelected[j];
            if (pax_range.id === paxRangeSelected.id) {
              visible = true;
              break;
            }
          }

          pax_range.visible = visible;
        });
      });
    }

    function saveTourPickupPrices() {
      var tourPickupPrices = [];

      vm.zonesData.forEach(function (zone) {
        zone.pax_ranges.forEach(function (pax_range) {
          if (pax_range.visible) {
            var price = {
              service_price: pax_range.service_price || 0,

              zone_id: zone.id,
              pax_range_id: pax_range.id,
              id: null,
            };

            if (pax_range.tourPickupPriceId) {
              price.id = pax_range.tourPickupPriceId;
            }

            tourPickupPrices.push(price);
          }
        });
      });

      var params = {
        tour_pickup_prices: tourPickupPrices,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
      };

      // console.log(params);
      // return;

      vm.sendingForm = true;
      TourPriceService.saveTourPickupPrices(vm.tour, params, vm.editMode).then(function (data) {
        vm.onTourPickupPricesSaved();

        setItemOptions(data[0].updated_at);

        vm.tourPickupPrices = data;
        setPaxRangesData();

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTourPickupPricesCanceled();
    }
  }
})();
